import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const label: SxStyleFunc<boolean | undefined> = (isCurrentTab) => ({
  /* fontSize: (p) => p.typography.body2.fontSize,
  fontWeight: isCurrentTab
    ? (p) => p.typography.fontWeightBold
    : (p) => p.typography.fontWeightMedium,
  color: isCurrentTab
    ? (p) => p.palette.primary[500]
    : (p) => p.palette.common.black, */
});

export const value: SxStyleFunc<boolean | undefined> = (isCurrentTab) => ({
  // fontSize: (p) => p.typography.body2.fontSize,
  // fontWeight: isCurrentTab
  //   ? (p) => p.typography.fontWeightBold
  //   : (p) => p.typography.fontWeightMedium,
  // color: isCurrentTab
  //   ? (p) => p.palette.common.white
  //   : (p) => p.palette.grey[700],
});

export const labelWrapper: SxStyle = {
  // display: 'flex',
  // flexDirection: 'row',
  // alignItems: 'center',
  // gap: (p) => p.spacing(1.25),
};

export const searchValueWrapper: SxStyleFunc<boolean | undefined> = (
  isCurrentTab
) => ({
  display: 'flex',
  alignItems: 'center',
  height: (p) => p.spacing(2.5),
  padding: (p) => p.spacing(0, 1),
  borderRadius: (p) => p.spacing(0.5),
  background: isCurrentTab
    ? (p) => p.palette.primary[500]
    : (p) => p.palette.grey[200],
  color: isCurrentTab
    ? (p) => p.palette.common.white
    : (p) => p.palette.grey[700],
});
